import { render, staticRenderFns } from "./treasury-kids.pug?vue&type=template&id=09ccdf16&scoped=true&lang=pug&external"
import script from "./treasury-kids.js?vue&type=script&lang=js&external"
export * from "./treasury-kids.js?vue&type=script&lang=js&external"
import style0 from "./treasury-kids.scss?vue&type=style&index=0&id=09ccdf16&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ccdf16",
  null
  
)

export default component.exports